import makeEvents from "../../../../helpers/event-creator.js";
const actions = ['add-show-clicked'];
const ACTIONS = [...actions];
const APP_EVENTS = makeEvents(ACTIONS);
export default APP_EVENTS;
